import { createApp, h } from 'vue/dist/vue.esm-bundler';
import ConfirmDialog from '../components/dialog/ConfirmDialog.vue';

class DialogService {
  constructor() {
    this.dialogs = [];
    this.maxDialogs = 5;
  }

  // Vue entegrasyonu
  install(app) {
    app.config.globalProperties.$dialog = this;
    window.showDialog = this.show.bind(this);
    return this;
  }

  confirm(options) {
    if (typeof options === 'string') {
      options = { text: options };
    }

    const defaultOptions = {
      heading: 'Onay',
      text: 'Bu işlemi yapmak istediğinizden emin misiniz?',
      type: 'info',
      confirmButtonText: 'Tamam',
      cancelButtonText: 'İptal',
      showCancelButton: true,
      showIcon: true,
      closeOnBackdropClick: true
    };

    return new Promise((resolve, reject) => {
      const dialogOptions = { ...defaultOptions, ...options };
      const dialog = this.show(dialogOptions);

      dialog.$on('confirm', () => {
        resolve(true);
      });

      dialog.$on('cancel', () => {
        resolve(false);
      });

      dialog.$on('close', () => {
        // Dialog kapatıldığında
      });
    });
  }

  warning(options) {
    if (typeof options === 'string') {
      options = { text: options };
    }

    const defaultOptions = {
      heading: 'Uyarı',
      text: 'Bu işlemi yapmak istediğinizden emin misiniz?',
      type: 'warning',
      confirmButtonText: 'Tamam',
      cancelButtonText: 'İptal',
      showCancelButton: true,
      showIcon: true,
      closeOnBackdropClick: true
    };

    return this.confirm({ ...defaultOptions, ...options });
  }

  delete(options) {
    if (typeof options === 'string') {
      options = { text: options };
    }

    const defaultOptions = {
      heading: 'Sil',
      text: 'Bu öğeyi silmek istediğinizden emin misiniz? Bu işlem geri alınamaz.',
      type: 'delete',
      confirmButtonText: 'Sil',
      cancelButtonText: 'İptal',
      showCancelButton: true,
      showIcon: true,
      closeOnBackdropClick: true
    };

    return this.confirm({ ...defaultOptions, ...options });
  }

  show(options) {
    if (typeof options === 'string') {
      options = { text: options };
    }

    const defaultOptions = {
      heading: null,
      text: '',
      type: 'info',
      confirmButtonText: 'Tamam',
      cancelButtonText: 'İptal',
      showCancelButton: true,
      showIcon: true,
      closeOnBackdropClick: true
    };

    const dialogOptions = { ...defaultOptions, ...options };

    if (this.dialogs.length > this.maxDialogs) {
      const oldDialog = this.dialogs.shift();
      if (oldDialog && oldDialog.$el && oldDialog.$el.parentNode) {
        oldDialog.$el.parentNode.removeChild(oldDialog.$el);
      }
    }
    
    const dialogDiv = document.createElement('div');
    document.body.appendChild(dialogDiv);

    const self = this;

    const app = createApp({
      render() {
        return h(ConfirmDialog, {
          ...dialogOptions,
          onConfirm: () => {
            app.$emit('confirm');
          },
          onCancel: () => {
            app.$emit('cancel');
          },
          onClose: () => {
            setTimeout(() => {
              app.unmount();
              if (dialogDiv.parentNode) {
                dialogDiv.parentNode.removeChild(dialogDiv);
              }
              if (self.dialogs) {
                self.dialogs = self.dialogs.filter(d => d !== app);
              }
              app.$emit('close');
            }, 300);
          }
        });
      }
    });

    // Özel event emitter'ı ekle
    app.$on = function(event, callback) {
      if (!this._events) this._events = {};
      if (!this._events[event]) this._events[event] = [];
      this._events[event].push(callback);
      return this;
    };

    app.$off = function(event, callback) {
      if (!this._events) return this;
      if (!callback) {
        this._events[event] = [];
        return this;
      }
      if (!this._events[event]) return this;
      this._events[event] = this._events[event].filter(cb => cb !== callback);
      return this;
    };

    app.$emit = function(event, ...args) {
      if (!this._events) return this;
      if (!this._events[event]) return this;
      this._events[event].forEach(callback => callback(...args));
      return this;
    };

    app.mount(dialogDiv);
    this.dialogs.push(app);

    return app;
  }
}

const dialogService = new DialogService();

window.showConfirm = (options) => dialogService.confirm(options);
window.showWarningConfirm = (options) => dialogService.warning(options);
window.showDeleteConfirm = (options) => dialogService.delete(options);

export default dialogService; 